// Helpers for formatting event times in user-friendly 12-hour format.

/**
 * Convert a 24-hour "HH:MM" string to 12-hour "h:mm AM/PM".
 * Returns an empty string if input is falsy. Returns input unchanged
 * if it doesn't look like HH:MM.
 */
export function fmtTime12(value) {
  if (!value) return "";
  const str = String(value);
  const match = str.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return str;
  let hours = parseInt(match[1], 10);
  const minutes = match[2];
  if (isNaN(hours)) return str;
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (hours === 0) hours = 12;
  return `${hours}:${minutes} ${period}`;
}

/**
 * Convert a stored date string (YYYY-MM-DD) to a friendly label like
 * "Mon, Mar 4, 2026". Falsy values return "".
 */
export function fmtDateFriendly(dateStr) {
  if (!dateStr) return "";
  // Using local time parse to avoid TZ shifts on pure date strings.
  const [y, m, d] = String(dateStr).split("-").map(Number);
  if (!y || !m || !d) return dateStr;
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/**
 * Auto-format a US phone number as the user types.
 * Strips non-digits, caps at 10, and renders XXX-XXX-XXXX.
 *   "7066310213"   → "706-631-0213"
 *   "70663"        → "706-63"
 *   "(843) 252-46" → "843-252-46"
 */
export function fmtPhone(value) {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
